<template>
  <f7-page
    name="diamantes"
    @infinite="$evento.emit('search:load')"
    :infinite-distance="50"
    :infinite-preloader="false"
    infinite
    :hide-bars-on-scroll="false"
  >
    <f7-navbar
      :sliding="false"
      innerClass="navbar-separator"
    >
      <!-- <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link> -->
      <f7-nav-title class="text-madai">Listado de Diamantes</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-md="material:search" href="/buscar/" @click="activarBusqueda = false"></f7-link>
      </f7-nav-right>

      <busqueda
        :activarBusqueda="activarBusqueda"
        :id="'busqueda'"
        :catalogo="catalogo"
        :filtros="filtros"
        @searchbar:disable="activarBusqueda = false"
        @search:load-complete="resp => catalogoPaginador = resp"
        @search:data="resp => catalogoFiltrado = resp"
      ></busqueda>
    </f7-navbar>

    <f7-toolbar class="h-60" position="top" tabbar scrollable>
      <f7-link class="text-filter-blue bold">
        Filtros
      </f7-link>
      <f7-link class="text-filter-blue bold p-t-4" @click="filtros[6].value = !filtros[6].value">
        <img v-if="filtros[6].value" src="assets/img/iconos/foto-360-off.svg" alt="" srcset="" width="36">
        <img v-else src="assets/img/iconos/foto-360-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          Foto 360
        </div>
      </f7-link>
      <f7-link
        v-for="(tab, index) in tabs.filter(itm => itm !== '360')"
        :class="{ 'filter-tabbar-selected': tabSeleccionada === index }"
        :key="tab"
        @click="filtroSeleccionado(index, tab)"
      >
        <!-- {{tab}} -->
        <template v-if="tab.toLowerCase() === 'forma'">
          <img src="assets/img/filtros/corte-on.svg" alt="" srcset="" width="36">
          <div class="fs-10 text-black bold">
          {{ filtros[1].value === '*' ? 'forma' : filtros[1].value }}
        </div></template>
        <template v-if="tab.toLowerCase() === 'precio'">
          <img src="assets/img/filtros/precio-on.svg" alt="" srcset="" width="36">
          <div class="fs-10 text-black bold">
          <!-- {{ $helper.str.formatearMoneda(filtros[0].minValue) + ' - ' + $helper.str.formatearMoneda(filtros[0].maxValue) }} -->
          {{ filtros[0].minValue === Math.trunc(priceMin) && filtros[0].maxValue === Math.trunc(priceMax) + 1 ? 'precio' : 'filtrado' }}
        </div></template>
        <template v-if="tab.toLowerCase() === 'quilataje'">
          <img src="assets/img/filtros/quilataje-diamante-on.svg" alt="" srcset="" width="36">
          <div class="fs-10 text-black bold">
          {{ filtros[2].minValue === caratMin && filtros[2].maxValue === caratMax ? 'quilates' : filtros[2].minValue + ' - ' + filtros[2].maxValue }}
        </div></template>
        <template v-if="tab.toLowerCase() === 'color'">
          <img src="assets/img/filtros/color-diamante-on.svg" alt="" srcset="" width="36">
          <div class="fs-10 text-black bold">
          {{ filtros[3].minValue === 0 && filtros[3].maxValue === 9 ? 'color' : formatearColor(filtros[3].minValue) + ' - ' + formatearColor(filtros[3].maxValue) }}
        </div></template>
        <template v-if="tab.toLowerCase() === 'claridad'">
          <img src="assets/img/filtros/claridad-diamante-on.svg" alt="" srcset="" width="36">
          <div class="fs-10 text-black bold">
          {{ filtros[4].minValue === 0 && filtros[4].maxValue === 10 ? 'claridad' : formatearClaridad(filtros[4].minValue) + ' - ' + formatearClaridad(filtros[4].maxValue) }}
        </div></template>
        <template v-if="tab.toLowerCase() === 'corte'">
          <img src="assets/img/filtros/corte-diamante-on.svg" alt="" srcset="" width="36">
          <div class="fs-10 text-black bold">
          {{ filtros[5].minValue === 0 && filtros[5].maxValue === 3 ? 'corte' : formatearCorte(filtros[5].minValue) + ' - ' + formatearCorte(filtros[5].maxValue) }}
        </div></template>
      </f7-link>
      <f7-link
        class="text-filter-blue bold"
        @click="limpiarFiltros()"
      >
        Reiniciar
      </f7-link>
    </f7-toolbar>
    <f7-tabs>
      <f7-tab v-for="(tab, index) in tabs" :key="tab" :id="`tab-${tab}`" :tab-active="index === 0"></f7-tab>
    </f7-tabs>

    <pasos></pasos>

    <!-- <f7-block v-if="cargando" class="m-t-80">
      <img src="assets/img/preloaders/descargando.gif" alt="" class="wd-100">
    </f7-block> -->

    <f7-list v-if="catalogoPaginador.length === 0 && cargando === false">
      <f7-list-item>No se encontraron resultados</f7-list-item>
    </f7-list>

    <template v-else>
      <f7-list class="searchbar-found m-t-10">
        <f7-list-item
          v-for="(itm, idx) in catalogoPaginador"
          :key="idx"
          link
          @click="buscarDiamante(itm.IdDiamond)"
        >
          <!-- <f7-row class="wd-100">
            <f7-col width="25">
              <template v-if="itm.DiamondImage !== '' && itm.DiamondImage !== 'NULL'">
                <img class="m-l-6" height="45" width="45" :src="itm.DiamondImage" alt="" style="border-radius: 50%; margin-top: -2px; position: relative; position: relative; left: 12px; top: 5px;">
                <div class="fs-10 text-danger bold p-l-7" style="position: absolute; bottom: 5px;">IMAGEN REAL</div>
              </template>
              <template v-else>
                <img class="wd-100" src="assets/img/otros/not-available.png" alt="" style="border-radius: 50%; margin-top: -2px; position: relative; position: relative; left: 12px; top: 5px;">
              </template>
            </f7-col>
            <f7-col width="75">
              <div class="item-cell">
                <div class="item-row">
                  <div class="item-cell bold text-right fs-11">Código</div>
                  <div class="item-cell text-left fs-11 item-search">{{ itm.ItemID }}</div>
                  <div class="item-cell bold text-right fs-11">Claridad</div>
                  <div class="item-cell text-left fs-11 item-search">{{ itm.Clarity }}</div>
                </div>
                <div class="item-row">
                  <div class="item-cell bold text-right fs-11">Forma</div>
                  <div class="item-cell text-left fs-11 item-search">{{ itm.Cut }}</div>
                  <div class="item-cell bold text-right fs-11">Color</div>
                  <div class="item-cell text-left fs-11 item-search">{{ itm.Color }}</div>
                </div>
                <div class="item-row">
                  <div class="item-cell bold text-right fs-11">Quilates</div>
                  <div class="item-cell text-left fs-11 item-search">{{ itm.Carat }}</div>
                  <div class="item-cell bold text-right fs-11">Corte</div>
                  <div class="item-cell text-left fs-11 item-search">{{ itm.MakeCutGrade.trim() === '' ? 'N/D' : itm.MakeCutGrade }}</div>
                </div>
                <div class="item-row">
                  <div class="item-cell text-right bold fs-11">Precio MXN</div>
                  <div class="item-cell fs-11 item-search text-danger bold">{{ $helper.str.formatearMoneda(itm.Price) }}</div>
                </div>
              </div>
            </f7-col>
          </f7-row> -->
          <f7-row class="wd-100">
            <f7-col class="text-center" width="40">
              <template v-if="itm.DiamondImage !== '' && itm.DiamondImage !== 'NULL'">
                <img class="m-t-10" :src="itm.DiamondImage" alt="" style="border-radius: 10px; width: 100px; margin: 0 auto;">
                <div class="fs-14 text-dark bold p-l-7 d-block text-center" style="">FOTO REAL</div>
              </template>
              <template v-else>
                <img :src="`assets/img/piedras/${obtenerForma(itm.Cut) !== 'corazón' ? obtenerForma(itm.Cut) : 'corazon'}.png`" alt="" style="width: 132px;">
              </template>
            </f7-col>
            <f7-col width="60">
              <div>
                <span class="text-uppercase bold fs-12 text-dark">ID: </span>
                <span class="fs-12 float-right m-t-3 text-uppercase">{{ itm.ItemID }}</span>
              </div>
              <div class="hide" style="margin-top: -3px;">
                <span class="text-uppercase bold fs-12 text-dark">Forma: </span>
                <span class="fs-12 float-right m-t-3 text-uppercase">{{ itm.Cut }}</span>
              </div>
              <div style="margin-top: -3px;">
                <span class="text-uppercase bold fs-12 text-dark">Quilates: </span>
                <span class="fs-12 float-right m-t-3 text-uppercase">{{ itm.Carat }}</span>
              </div>
              <div style="margin-top: -3px;">
                <span class="text-uppercase bold fs-12 text-dark">Claridad: </span>
                <span class="fs-12 float-right m-t-3 text-uppercase">{{ itm.Clarity }}</span>
              </div>
              <div style="margin-top: -3px;">
                <span class="text-uppercase bold fs-12 text-dark">Color: </span>
                <span class="fs-12 float-right m-t-3 text-uppercase">{{ itm.Color }}</span>
              </div>
              <div style="margin-top: -3px;">
                <span class="text-uppercase bold fs-12 text-dark">Corte: </span>
                <span class="fs-12 float-right m-t-3 text-uppercase">{{ itm.MakeCutGrade.trim() === '' ? 'N/D' : itm.MakeCutGrade }}</span>
              </div>
              <div class="m-b-0 p-l-10 p-r-10 p-t-3 p-b-5 text-center" style="border-radius: 5px;">
                <span class="text-uppercase bold fs-12 text-dark m-r-5">MXN: </span>
                <span class="fs-12 text-uppercase bold" style="color: #309400;">
                  {{ $helper.str.formatearMoneda(itm.Price) }}
                </span>
              </div>
            </f7-col>
          </f7-row>
        </f7-list-item>
      </f7-list>
    </template>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'precio'" @sheet:closed="filtro = ''; tabSeleccionada = null">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Precio</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-list simple-list class="m-0 m-t-20 f7-list-item-no-border p-l-25 p-r-25">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3">
              <f7-range
                ref="precio"
                :min="priceMin"
                :max="priceMax"
                :step="1"
                :value="[filtros[0].minValue, filtros[0].maxValue]"
                :label="true"
                :dual="true"
                @range:change="precioActualizado"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
        <f7-row>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                class="text-center"
                label="Mínimo"
                type="number"
                placeholder="Mínimo"
                @focus="delayFocus = true"
                @blur="delayFocus = false"
                :value="filtros[0].minValue"
                @input="filtros[0].minValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                class="text-center"
                label="Máximo"
                type="number"
                placeholder="Máximo"
                @focus="delayFocus = true"
                @blur="delayFocus = false"
                :value="filtros[0].maxValue"
                @input="filtros[0].maxValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'quilataje'" @sheet:closed="filtro = ''; tabSeleccionada = null">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Quilataje</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-list simple-list class="m-0 m-t-20 f7-list-item-no-border p-l-25 p-r-25">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3">
              <f7-range
                ref="quilataje"
                :min="caratMin"
                :max="caratMax"
                :step="0.01"
                :value="[filtros[2].minValue, filtros[2].maxValue]"
                :label="true"
                :dual="true"
                @range:change="quilatajeActualizado"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
        <f7-row>
          <f7-col></f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                class="text-center"
                label="Mínimo"
                type="number"
                placeholder="Mínimo"
                @focus="delayFocus = true"
                @blur="delayFocus = false"
                :value="filtros[2].minValue"
                @input="filtros[2].minValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                class="text-center"
                label="Máximo"
                type="number"
                placeholder="Máximo"
                @focus="delayFocus = true"
                @blur="delayFocus = false"
                :value="filtros[2].maxValue"
                @input="filtros[2].maxValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'color'" @sheet:closed="filtro = ''; tabSeleccionada = null">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Color</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="p-t-20 p-l-45 p-r-45">
          <f7-col>
            <img src="assets/img/detalles/color_d_filtro.svg" alt="" srcset="" height="30">
          </f7-col>
          <f7-col class="text-center">
            <img src="assets/img/detalles/color_i_filtro.svg" alt="" srcset="" height="30">
          </f7-col>
          <f7-col class="text-right">
            <img src="assets/img/detalles/color_k_m_filtro.svg" alt="" srcset="" height="30">
          </f7-col>
        </f7-row>
        <f7-list simple-list class="m-0 f7-list-item-no-border p-l-25 p-r-25">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3 m-t-40">
              <f7-range
                ref="color"
                :format-label="formatearColor"
                :format-scale-label="formatearColor"
                :min="0"
                :max="9"
                :step="1"
                :value="[filtros[3].minValue, filtros[3].maxValue]"
                :label="true"
                :dual="true"
                :scale="true"
                :scale-steps="9"
                :scale-sub-steps="1"
                @range:change="colorActualizado"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'claridad'" @sheet:closed="filtro = ''; tabSeleccionada = null">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Claridad</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="p-t-20 p-l-20 p-r-20">
          <f7-col>
            <img src="assets/img/detalles/claridad_fl_filtro.svg" alt="" srcset="" height="30">
          </f7-col>
          <f7-col class="text-center">
            <img src="assets/img/detalles/claridad_vs1_vs2_filtro.svg" alt="" srcset="" height="30">
          </f7-col>
          <f7-col class="text-right">
            <img src="assets/img/detalles/claridad_i3_filtro.svg" alt="" srcset="" height="30">
          </f7-col>
        </f7-row>
        <f7-list simple-list class="m-0 f7-list-item-no-border">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon> -->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3 m-t-40">
              <f7-range
                ref="claridad"
                :format-label="formatearClaridad"
                :format-scale-label="formatearClaridad"
                :min="0"
                :max="10"
                :step="1"
                :value="[filtros[4].minValue, filtros[4].maxValue]"
                :label="true"
                :dual="true"
                :scale="true"
                :scale-steps="10"
                :scale-sub-steps="1"
                @range:change="claridadActualizado"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-240 sheet-border-radius-15" :opened="filtro === 'corte'" @sheet:closed="filtro = ''; tabSeleccionada = null">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Corte</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="p-t-20 p-l-20 p-r-15">
          <f7-col>
            <img src="assets/img/filtros/ex.svg" alt="" srcset="" height="45">
          </f7-col>
          <f7-col class="text-center">
            <img src="assets/img/filtros/vg.svg" alt="" srcset="" height="45">
          </f7-col>
          <f7-col class="text-center">
            <img src="assets/img/filtros/g.svg" alt="" srcset="" height="45">
          </f7-col>
          <f7-col class="text-right">
            <img src="assets/img/filtros/f.svg" alt="" srcset="" height="45">
          </f7-col>
        </f7-row>
        <f7-list simple-list class="m-0 f7-list-item-no-border">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3 m-t-40">
              <f7-range
                ref="corte"
                :format-label="formatearCorte"
                :format-scale-label="formatearCorte"
                :min="0"
                :max="3"
                :step="1"
                :value="[filtros[5].minValue, filtros[5].maxValue]"
                :label="true"
                :dual="true"
                :scale="true"
                :scale-steps="3"
                :scale-sub-steps="1"
                @range:change="corteActualizado"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-370 sheet-border-radius-15" :opened="filtro === 'forma'" @sheet:closed="filtro = ''; tabSeleccionada = null">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Forma</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'redondo' }"
            @click="filtros[1].value === 'redondo' ? filtros[1].value = '*' : filtros[1].value = 'redondo'"
          >
            <img src="assets/img/corte/redondo.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Redondo</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'princesa' }"
            @click="filtros[1].value === 'princesa' ? filtros[1].value = '*' : filtros[1].value = 'princesa'"
          >
            <img src="assets/img/corte/princess.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Princesa</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'asscher' }"
            @click="filtros[1].value === 'asscher' ? filtros[1].value = '*' : filtros[1].value = 'asscher'"
          >
            <img src="assets/img/corte/asscher.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Asscher</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'corazón' }"
            @click="filtros[1].value === 'corazón' ? filtros[1].value = '*' : filtros[1].value = 'corazón'"
          >
            <img src="assets/img/corte/corazon.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Corazón</span>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'cushion' }"
            @click="filtros[1].value === 'cushion' ? filtros[1].value = '*' : filtros[1].value = 'cushion'"
          >
            <img src="assets/img/corte/cushion.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Cushion</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'esmeralda' }"
            @click="filtros[1].value === 'esmeralda' ? filtros[1].value = '*' : filtros[1].value = 'esmeralda'"
          >
            <img src="assets/img/corte/esmeralda.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Esmeralda</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'marquesa' }"
            @click="filtros[1].value === 'marquesa' ? filtros[1].value = '*' : filtros[1].value = 'marquesa'"
          >
            <img src="assets/img/corte/marquesa.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Marquesa</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'ovalado' }"
            @click="filtros[1].value === 'ovalado' ? filtros[1].value = '*' : filtros[1].value = 'ovalado'"
          >
            <img src="assets/img/corte/ovalado.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Ovalado</span>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'pera' }"
            @click="filtros[1].value === 'pera' ? filtros[1].value = '*' : filtros[1].value = 'pera'"
          >
            <img src="assets/img/corte/pera.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Pera</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'radiant' }"
            @click="filtros[1].value === 'radiant' ? filtros[1].value = '*' : filtros[1].value = 'radiant'"
          >
            <img src="assets/img/corte/radiant.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Radiant</span>
          </f7-col>
          <f7-col></f7-col>
          <f7-col></f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-popup
      :opened="popup === 'detalle-diamante'"
      @popup:closed="popup = ''; diamante = {}; ver = 'foto';" >
      <f7-page v-if="diamante.ItemID">
        <f7-navbar
          class="bg-madai"
        >
          <f7-nav-title class="text-white">Detalles del diamante</f7-nav-title>
          <f7-nav-right>
            <f7-link class="text-white" popup-close>Cerrar</f7-link>
          </f7-nav-right>
        </f7-navbar>

        <template v-if="ver === 'foto'">
          <f7-block class="m-b-15 h-380" style="position: relative; left: 50%; transform: translate(-50%, 0%); display: inline-block;">
            <template v-if="diamante.DiamondImage">
              <span class="bold" style="position: absolute; left: 30px; top: 10px;">FOTO REAL</span>
              <img class="wd-100" :src="diamante.DiamondImage" alt="">
            </template>
            <template v-else>
              <img class="wd-100" :src="`assets/img/piedras/${obtenerForma(diamante.Cut) !== 'corazón' ? obtenerForma(diamante.Cut) : 'corazon'}.png`" alt="">
            </template>
          </f7-block>
        </template>
        <template v-if="ver === '360'">
          <f7-block class="m-b-15 h-380 p-l-0 p-r-0" style="position: relative; left: 50%; transform: translate(-50%, 0%); display: inline-block;">
            <f7-row>
              <f7-col class="text-center" v-if="diamante.DiamondVideo && diamante.DiamondVideo.length>2" style="z-index:9; overflow: hidden;">
                <iframe ref="video360" :src="diamante.DiamondVideo" scrolling="no" class="w-360 margin-auto" height="360" frameborder="0"></iframe>
              </f7-col>
              <f7-col v-else style="z-index:9">
                <img class="wd-100" src="assets/img/otros/not-available.png" alt="" srcset="">
              </f7-col>
            </f7-row>
            <f7-preloader color="black" style="position: absolute; left:50%; top:140px;"></f7-preloader>
          </f7-block>
        </template>
        <template v-else-if="ver === 'detalles1'">
          <div class="w-140" style="position:absolute; top: 405px; right:0px; z-index: 20">
            <f7-button class="float-left h-50 w-50 m-r-15" @click="ver = 'detalles1'" color="white" fill>
              <img class="m-t-7" src="assets/img/iconos/medida_a.svg" alt="" width="35">
            </f7-button>
            <f7-button class="float-left h-50 w-50" @click="ver = 'detalles2'" color="white" fill raised>
              <img class="m-t-7" src="assets/img/iconos/medida_b.svg" alt="" width="35">
            </f7-button>
          </div>
          <f7-block class="m-b-15 h-380">
            <f7-row>
              <f7-col style="overflow: hidden; margin-top: -20px;">
                <div :style="`position: absolute; top: ${posXY[obtenerForma(diamante.Cut)].girdle.y}; padding-right: ${posXY[obtenerForma(diamante.Cut)].girdle.x}; left: 50%; transform: translate(-50%, -50%); display: inline-block; z-index: 99;`">
                  <div style="position: relative; background-color: #FFF; text-align: center;">Girlde: {{ diamante.Girdle === 'NULL' ? 'N/D' : diamante.Girdle }}</div>
                </div>
                <div :style="`position: absolute; background-color: #FFF; padding: 0 3px; top: ${posXY[obtenerForma(diamante.Cut)].table.y}; left: 50%; transform: translate(-50%, -50%); display: inline-block; z-index: 99`">Table: {{ diamante.TableAttr }}%</div>
                <div :style="`position: absolute; background-color: #FFF; padding: 0 3px; top: ${posXY[obtenerForma(diamante.Cut)].culet.y}; padding-left: ${posXY[obtenerForma(diamante.Cut)].culet.x}; left: 50%; transform: translate(-50%, -50%); display: inline-block; z-index: 99`">Culet: {{ diamante.CuletSize === 'NULL' ? 'N/D' : diamante.CuletSize}}</div>
                <div :style="`position: absolute; left: 50%; top: ${posXY[obtenerForma(diamante.Cut)].depth.y}; padding-left: ${posXY[obtenerForma(diamante.Cut)].depth.x}; transform: translate(-50%, -50%); display: inline-block; z-index: 99;`">
                  <div style="position: relative; background-color: #FFF; text-align: center; width: 65px;">Depth: {{diamante.Depth}} %</div>
                </div>
                <img class="w-350 d-block" style="position: relative; left: 50%; transform: translate(-50%, 0%);" :src="`assets/img/piedras/${obtenerForma(diamante.Cut)}_1.jpg`" alt="">
              </f7-col>
            </f7-row>
          </f7-block>
        </template>
        <template v-else-if="ver === 'detalles2'">
          <div class="w-140" style="position:absolute; top: 405px; right:0px; z-index: 20">
            <f7-button class="float-left h-50 w-50 m-r-15" @click="ver = 'detalles1'" color="white" fill raised>
              <img class="m-t-7" src="assets/img/iconos/medida_a.svg" alt="" width="35">
            </f7-button>
            <f7-button class="float-left h-50 w-50" @click="ver = 'detalles2'" color="white" fill>
              <img class="m-t-7" src="assets/img/iconos/medida_b.svg" alt="" width="35">
            </f7-button>
          </div>
          <f7-block class="m-b-15 h-380">
            <f7-row>
              <f7-col style="overflow: hidden; margin-top: -20px;">
                <div :style="`position: absolute; top: ${posXY[obtenerForma(diamante.Cut)].length.y}; padding-right: ${posXY[obtenerForma(diamante.Cut)].length.x}; left: 50%; transform: translate(-50%, -50%); display: inline-block; z-index: 99;`">
                  <div style="position: relative; background-color: #FFF; text-align: center;">Length: {{ diamante.Measurements === 'NULL' ? 'N/D' : diamante.Measurements.split('x')[1] }}</div>
                </div>
                <div :style="`position: absolute; background-color: #FFF; padding: 0 3px; top: ${posXY[obtenerForma(diamante.Cut)].width.y}; left: 50%; transform: translate(-50%, -50%); display: inline-block; z-index: 99`">Width: {{ diamante.Measurements === 'NULL' ? 'N/D' : diamante.Measurements.split('x')[0] }}</div>
                <img class="w-350 d-block" style="position: relative; left: 50%; transform: translate(-50%, 0%);" :src="`assets/img/piedras/${obtenerForma(diamante.Cut)}_2.jpg`" alt="">
              </f7-col>
            </f7-row>
          </f7-block>
        </template>

        <f7-block class="m-t-0 p-t-10 p-b-10" style="background-color: dimgrey;">
          <f7-row>
            <f7-col>
              <f7-button class="h-60" @click="ver = 'foto'" color="white" fill raised>
                <img class="m-t-3" :src="`assets/img/corte/${ver === 'foto' ? obtenerForma(diamante.Cut) + '-seleccionado' : obtenerForma(diamante.Cut)}.svg`" alt="" width="55">
              </f7-button>
            </f7-col>
            <f7-col>
              <f7-button class="h-60" @click="ver = '360'" color="white" fill raised>
                <img class="m-t-10"
                  alt="" srcset="" width="45"
                  :src="`assets/img/iconos/foto-360-${ver === '360' ? 'seleccionado' : 'on' }.svg`">
              </f7-button>
            </f7-col>
            <f7-col>
              <f7-button class="h-60 p-t-4" @click="ver = 'detalles1'" color="white" fill raised>
                <img class="" :src="`assets/img/iconos/${ver === 'detalles1' || ver === 'detalles2' ? 'medida-seleccionado' : 'medida' }.svg`" alt="" width="50">
              </f7-button>
            </f7-col>
            <f7-col>
              <template v-if="diamante.UrlCertificate !== '' && diamante.UrlCertificate !== 'NULL'">
                <f7-button class="h-60" :href="'https://api.madai.mx/api/madai/v0/certificado/' + diamante.UrlCertificate.replace('https://assets.ddpl.com/certificate/', '')" target="_blank" :external="true" color="white" fill raised>
                <!-- <f7-button class="h-60" :href="'http://madai-server.herokuapp.com/api/madai/v0/certificado/' + diamante.UrlCertificate.replace('https://assets.ddpl.com/certificate/', '')" target="_blank" :external="true" color="white" fill raised> -->
                  <img class="m-t-10" src="assets/img/iconos/pdf.svg" alt="" width="40">
                </f7-button>
              </template>
              <template v-else>
                <f7-button class="h-60" color="white" fill raised>
                  <img class="m-t-10" src="assets/img/iconos/pdf-off.svg" alt="" width="40">
                </f7-button>
              </template>
            </f7-col>
          </f7-row>
          <!-- <f7-row class="m-t-10" v-if="diamante.UrlCertificate !== '' && diamante.UrlCertificate !== 'NULL'">
            <f7-col>
              <f7-button class="text-uppercase text-madai bold" :href="'http://madai-server.herokuapp.com/api/madai/v0/certificado/' + diamante.UrlCertificate.replace('https://assets.ddpl.com/certificate/', '')" target="_blank" :external="true" color="white" fill raised>
                Ver certificado
              </f7-button>
            </f7-col>
          </f7-row> -->
        </f7-block>

        <f7-row>
          <f7-col>
            <f7-list class="m-0">
              <f7-list-item header="ID" :title="diamante.ItemID.replace('NULL', '-') || '-'" />
              <f7-list-item header="Forma" :title="diamante.Cut.replace('NULL', '-') || '-'" />
              <f7-list-item header="Quilaje" :title="diamante.Carat.replace('NULL', '-') || '-'" />
              <f7-list-item header="Color" :title="diamante.Color.replace('NULL', '-') || '-'" />
              <f7-list-item header="Claridad" :title="diamante.Clarity.replace('NULL', '-') || '-'" />
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="m-0">
              <f7-list-item header="Corte" :title="diamante.MakeCutGrade.trim() === '' ? 'N/D' : diamante.MakeCutGrade" />
              <f7-list-item header="Certificado" :title="diamante.Lab.replace('NULL', '-') || '-'" />
              <f7-list-item header="Precio" :title="$helper.str.formatearMoneda(diamante.Price) + ' MXN'" />
              <f7-list-item header="Polish" :title="diamante.Polish.replace('NULL', '-') || '-'" />
              <f7-list-item header="Simetría" :title="diamante.Symmetry.replace('NULL', '-') || '-'" />
            </f7-list>
          </f7-col>
        </f7-row>
        <hr class="m-t-0 m-b-0">
        <f7-row class="hide">
          <f7-col>
            <f7-list class="m-0 m-b-20">
              <f7-list-item header="Certificado" :title="diamante.Certificate.replace('NULL', '-') || '-'" />
              <f7-list-item :external="true" target="_blank" :link="diamante.UrlCertificate.replace('NULL', '#')" header="Certificado Número" :title="diamante.UrlCertificate.replace('NULL', '-') || '-'" />
              <f7-list-item :external="true" target="_blank" :link="diamante.DiamondImage.replace('NULL', '#')" header="Imagen" :title="diamante.DiamondImage.replace('NULL', '-') || '-'" />
              <!-- <f7-list-item :external="true" target="_blank" :link="diamante.DiamondVideo.replace('NULL', '#')" header="Video 360" :title="diamante.DiamondVideo.replace('NULL', '-') || '-'" /> -->
            </f7-list>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col>
            <f7-list class="m-b-10" inset>
              <f7-list-item>
                <f7-button class="margin-auto wd-100" outline :href="storage.montura ? '/completar/' : '/compromiso/'" @click="storage.diamante = diamante.IdDiamond" popup-close>
                  Seleccionar diamante
                </f7-button>
              </f7-list-item>
            </f7-list>
          </f7-col>
        </f7-row>

        <f7-row>
          <f7-col>
            <f7-list class="m-t-0" inset>
              <f7-list-item>
                <f7-row class="wd-100">
                  <f7-col width="50">
                    <f7-button outline class="wd-100" :color="carrito.find(art => art.IdDiamond === diamante.IdDiamond) ? 'green' : ''" @click="agregarCarrito(diamante)">
                      <span class="fs-12">{{ carrito.find(art => art.IdDiamond === diamante.IdDiamond) ? 'En carrito' : 'Al Carrito'}}</span>
                    </f7-button>
                  </f7-col>
                  <f7-col width="50">
                    <f7-button fill class="wd-100" @click="agregarCarrito(diamante, true)"><span class="fs-12">Proceder a pagar</span></f7-button>
                  </f7-col>
                </f7-row>
              </f7-list-item>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-page>
    </f7-popup>

    <!-- <f7-toolbar class="bg-madai" bottom>
      <f7-link class="text-white" :icon-md="filtros[6].value ? `material:videocam` : `material:videocam_off`"  @click="filtros[6].value = !filtros[6].value"></f7-link>
      <p class="fs-11 text-white margin-auto">Mostrando {{ catalogoPaginador.length }} de {{ catalogoFiltrado.length }} resultados de {{ catalogo.length }} registros.</p>
      <f7-link class="text-white" icon-md="material:refresh" @click="limpiarFiltros()"></f7-link>
    </f7-toolbar> -->
  </f7-page>
</template>

<script>
import busqueda from '@/components/busqueda'
import pasos from '@/components/pasos'
import _ from 'lodash'

export default {
  components: {
    busqueda,
    pasos
  },
  data () {
    return {
      cargando: true,
      activarBusqueda: false,
      delayFocus: false,
      catalogo: [],
      catalogoFiltrado: [],
      catalogoPaginador: [],
      delayBusqueda: null,
      diamante: {},
      filtroTemp: null,
      filtros: [
        {
          prop: 'Price',
          minValue: 0,
          maxValue: 0
        },
        {
          prop: 'Cut',
          value: '*'
        },
        {
          prop: 'Carat',
          minValue: 0,
          maxValue: 0
        },
        {
          prop: 'Color',
          minValue: 0,
          maxValue: 9
        },
        {
          prop: 'Clarity',
          minValue: 0,
          maxValue: 10
        },
        {
          prop: 'MakeCutGrade',
          minValue: 0,
          maxValue: 3
        },
        {
          prop: 'DiamondImage',
          value: false,
          regex: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/
        }
      ],
      posXY: {
        redondo: {
          girdle: { x: '220px', y: '235px' },
          table: { y: '47px' },
          culet: { x: '0px', y: '285px' },
          depth: { y: '150px', x: '235px' },
          length: { y: '145px', x: '220px' },
          width: { y: '270px' }
        },
        princesa: {
          girdle: { x: '140px', y: '255px' },
          table: { y: '78px' },
          culet: { x: '0px', y: '285px' },
          depth: { y: '180px', x: '235px' },
          length: { y: '100px', x: '75px' },
          width: { y: '203px' }
        },
        asscher: {
          girdle: { x: '140px', y: '235px' },
          table: { y: '68px' },
          culet: { x: '0px', y: '295px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '100px', x: '75px' },
          width: { y: '189px' }
        },
        corazón: {
          girdle: { x: '115px', y: '235px' },
          table: { y: '48px' },
          culet: { x: '40px', y: '300px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '125px', x: '225px' },
          width: { y: '238px' }
        },
        cushion: {
          girdle: { x: '150px', y: '205px' },
          table: { y: '65px' },
          culet: { x: '0px', y: '295px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '100px', x: '70px' },
          width: { y: '188px' }
        },
        esmeralda: {
          girdle: { x: '135px', y: '200px' },
          table: { y: '70px' },
          culet: { x: '0px', y: '270px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '100px', x: '70px' },
          width: { y: '200px' }
        },
        marquesa: {
          girdle: { x: '135px', y: '200px' },
          table: { y: '80px' },
          culet: { x: '0px', y: '255px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '135px', x: '170px' },
          width: { y: '265px' }
        },
        ovalado: {
          girdle: { x: '135px', y: '200px' },
          table: { y: '66px' },
          culet: { x: '0px', y: '265px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '105px', x: '115px' },
          width: { y: '188px' }
        },
        pera: {
          girdle: { x: '135px', y: '200px' },
          table: { y: '72px' },
          culet: { x: '75px', y: '270px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '95px', x: '55px' },
          width: { y: '185px' }
        },
        radiant: {
          girdle: { x: '150px', y: '220px' },
          table: { y: '45px' },
          culet: { x: '0px', y: '295px' },
          depth: { y: '155px', x: '235px' },
          length: { y: '115px', x: '65px' },
          width: { y: '200px' }
        },
        trillion: []
      },
      filtro: '',
      priceMin: 0,
      priceMax: 0,
      caratMin: 0,
      caratMax: 0,
      tabs: ['Forma', 'Precio', 'Quilataje', 'Color', 'Claridad', 'Corte', '360'],
      tabSeleccionada: null,
      popup: '',
      montura: {},
      ver: 'foto'
    }
  },
  watch: {
    ver (val) {
      if (val === '360') {
        // Enviar a iframe links para video 360
        // if (Array.isArray(this.diamante.DiamondVideo)) {
        //   this.$utils.nextTick(() => {
        //     this.$refs.video360.contentWindow.postMessage(this.diamante.DiamondVideo, '*')
        //   }, 500)
        // }
      }
    }
  },
  computed: {
    carrito () {
      return typeof this.storage.carrito === 'string' ? JSON.parse(this.storage.carrito) : this.storage.carrito
    }
  },
  methods: {
    async init () {
      try {
        this.cargando = true
        this.$f7.dialog.preloader('Descargando catálogo...')

        if (this.storage.montura !== '') {
          // Movi este código aqui para filtrar lo antes posibles los tabs
          // y que no se vea que se desaparece un botón en caso de haberse
          // seleccionado una montura
          this.montura = await this.$api.catalogo.detallesCompromiso(this.storage.montura)
          this.tabs = this.tabs.filter(tab => tab !== 'Forma')
        }

        this.catalogo = await this.$api.catalogo.diamantes()
        this.buscarPrecioMinMax()
        this.buscarQuilatajeMinMax()
        this.$f7.dialog.close()
        this.cargando = false

        if (this.$f7.router.context && this.$f7.router.context.forma) {
          let forma = this.$f7.router.context.forma
          this.filtros[1].value = forma
        }

        if (this.filtroTemp === null) {
          this.filtroTemp = _.cloneDeep(this.filtros)
        }

        // Cambiamos filtros de quilataje y corte si esta seleccionada una montura
        if (this.storage.montura !== '') {
          // let piedraCentral = this.montura.c_weight.replace(/\s/g, '').replace(/QT/g, '').split('-')
          this.$set(this.filtros, 1, { prop: 'Cut', value: this.obtenerForma(this.montura.c_cut) })

          // if (piedraCentral.length === 2) {
          //   let min = Number(piedraCentral[0])
          //   let max = 0
          //   if (piedraCentral[1] !== 'X') {
          //     max = Number(piedraCentral[1])
          //   } else {
          //     max = this.filtros[2].maxValue
          //   }
          //   this.$refs.quilataje.f7Range.min = min
          //   this.$refs.quilataje.f7Range.max = max
          //   this.$set(this.filtros, 2, { prop: 'Carat', minValue: min, maxValue: max })
          // }
        }
      } catch (err) {
        this.catalogo = []
        this.cargando = false
        this.$f7.dialog.close()
      }
    },
    agregarCarrito (pieza, redireccionar) {
      if (this.carrito.find(art => art.IdDiamond === pieza.IdDiamond) === undefined) {
        this.storage.carrito.push(pieza)
      } else {
        // this.$f7.dialog.alert('El artículo ya se agregó al carrito.', `MADAI`, () => {})
        redireccionar = true
      }

      if (redireccionar) {
        this.$f7.views.main.router.navigate('/carrito/', { reloadCurrent: true })
        this.popup = ''
      }
    },
    buscarPrecioMinMax () {
      // Buscar precios mínimos y máximos
      this.catalogo.forEach((item, idx) => {
        if (idx === 0) {
          this.priceMin = Number(item.Price)
          this.priceMax = Number(item.Price)
        }
        this.priceMin = Number(item.Price) < this.priceMin ? Number(item.Price) : this.priceMin
        this.priceMax = Number(item.Price) > this.priceMax ? Number(item.Price) : this.priceMax
      })
      // Asignar precios mínimos y máximos a filtros y range
      this.filtros[0].minValue = this.$refs.precio.f7Range.min = Math.floor(this.priceMin)
      this.filtros[0].maxValue = this.$refs.precio.f7Range.max = Math.ceil(this.priceMax)
    },
    buscarQuilatajeMinMax () {
      // Buscar quilatajes mínimos y máximos
      this.catalogo.forEach((item, idx) => {
        if (idx === 0) {
          this.caratMin = Number(item.Carat)
          this.caratMax = Number(item.Carat)
        }
        this.caratMin = Number(item.Carat) < this.caratMin ? Number(item.Carat) : this.caratMin
        this.caratMax = Number(item.Carat) > this.caratMax ? Number(item.Carat) : this.caratMax
      })
      // Asignar quilatajes mínimos y máximos a filtros y range
      this.filtros[2].minValue = this.$refs.quilataje.f7Range.min = this.caratMin
      this.filtros[2].maxValue = this.$refs.quilataje.f7Range.max = this.caratMax
    },
    async buscarDiamante (id) {
      try {
        this.$f7.dialog.preloader('Un momento por favor...')
        this.diamante = await this.$api.catalogo.detallesDiamante(id)
        this.popup = 'detalle-diamante'
        this.$f7.dialog.close()
      } catch (err) {}
    },
    formatearColor (val) {
      let labels = ['M', 'L', 'K', 'J', 'I', 'H', 'G', 'F', 'E', 'D'].reverse()
      return labels[val]
    },
    formatearClaridad (val) {
      let labels = ['I3', 'I2', 'I1', 'SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'].reverse()
      return labels[val]
    },
    formatearCorte (val) {
      let labels = ['F', 'G', 'VG', 'EX'].reverse()
      return labels[val]
    },
    filtroSeleccionado (id, tab) {
      this.tabSeleccionada = id
      this.filtro = tab.toLowerCase()
    },
    limpiarFiltros () {
      let times = 0
      let interval = setInterval(() => {
        this.$refs.precio.setValue([this.priceMin, this.priceMax])
        this.$refs.quilataje.setValue([this.caratMin, this.caratMax])
        this.$refs.color.setValue([0, 9])
        this.$refs.claridad.setValue([0, 10])
        this.$refs.corte.setValue([0, 3])
        // this.filtros.forEach((itm, idx) => {
        //   if (this.filtros[idx].value) { if (idx !== 6) { this.filtros[idx].value = '*'} else { this.filtros[6].value = false } }
        // })
        times++
        if (times === 4) {
          clearInterval(interval)
        }
      }, 0)

      this.filtros = _.cloneDeep(this.filtroTemp)
      this.showToastIcon('Filtros reseteados...')
    },
    precioActualizado (values) {
      clearTimeout(this.delayBusqueda)
      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 0, { minValue: this.$helper.num.redondear(values[0]), maxValue: this.$helper.num.redondear(values[1]), prop: 'Price' })
      }, this.delayFocus ? 4000 : 250)
    },
    quilatajeActualizado (values) {
      clearTimeout(this.delayBusqueda)
      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 2, { minValue: this.$helper.num.redondear(values[0]), maxValue: this.$helper.num.redondear(values[1]), prop: 'Carat' })
      }, this.delayFocus ? 4000 : 250)
    },
    colorActualizado (values) {
      clearTimeout(this.delayBusqueda)
      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 3, { minValue: values[0], maxValue: values[1], prop: 'Color' })
      }, 250)
    },
    claridadActualizado (values) {
      clearTimeout(this.delayBusqueda)
      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 4, { minValue: values[0], maxValue: values[1], prop: 'Clarity' })
      }, 250)
    },
    corteActualizado (values) {
      clearTimeout(this.delayBusqueda)
      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 5, { minValue: values[0], maxValue: values[1], prop: 'MakeCutGrade' })
      }, 250)
    },
    showToastIcon (mensaje, ms = 2000) {
      let toastIcon = this.$f7.toast.create({
        text: mensaje,
        position: 'center',
        closeTimeout: ms
      })
      toastIcon.open()

      setTimeout(() => {
        this.$f7.toast.close()
        toastIcon.destroy()
      }, ms + 150)
    },
    obtenerPosXY (forma) {
      if (forma.toUpperCase() === 'REDONDO') {
        return 'redondo'
      } else if (forma.toUpperCase() === 'RADIANTE') {
        return 'radiant'
      } else if (forma.toUpperCase() === 'PRINCESS' || forma.toUpperCase() === 'PRINCESA') {
        return 'princesa'
      } else if (forma.toUpperCase() === 'ASSCHER') {
        return 'asscher'
      } else if (forma.toUpperCase() === 'CUSHION') {
        return 'cushion'
      } else if (forma.toUpperCase() === 'MARQUEZA') {
        return 'marquesa'
      } else if (forma.toUpperCase() === 'ESMERALDA') {
        return 'esmeralda'
      } else if (forma.toUpperCase() === 'CORAZON' || forma.toUpperCase() === 'CORAZÓN') {
        return 'corazón'
      } else if (forma.toUpperCase() === 'OVALADO') {
        return 'ovalado'
      } else if (forma.toUpperCase() === 'PERA') {
        return 'pera'
      } else if (forma.toUpperCase() === 'TRILLION') {
        return 'trillion'
      }
      return forma.toLowerCase()
    },
    obtenerForma (forma) {
      if (forma.toUpperCase() === 'REDONDO') {
        return 'redondo'
      } else if (forma.toUpperCase() === 'RADIANTE') {
        return 'radiant'
      } else if (forma.toUpperCase() === 'PRINCESS' || forma.toUpperCase() === 'PRINCESA') {
        return 'princesa'
      } else if (forma.toUpperCase() === 'ASSCHER') {
        return 'asscher'
      } else if (forma.toUpperCase() === 'CUSHION') {
        return 'cushion'
      } else if (forma.toUpperCase() === 'MARQUEZA') {
        return 'marquesa'
      } else if (forma.toUpperCase() === 'ESMERALDA') {
        return 'esmeralda'
      } else if (forma.toUpperCase() === 'CORAZON') {
        return 'corazon'
      } else if (forma.toUpperCase() === 'OVALADO') {
        return 'ovalado'
      } else if (forma.toUpperCase() === 'PERA') {
        return 'pera'
      } else if (forma.toUpperCase() === 'TRILLION') {
        return 'trillion'
      }
      return forma.toLowerCase()
    }
  },
  created () {
    setTimeout(() => {
      this.init()
    }, 250)
  }
}
</script>

<style>
.actions-grid .actions-button {
  width: 20% !important;
}
.text-primary {
  color: #000;
}
</style>
